import { EventEmitter } from 'events';
import includes from 'lodash/includes';
import { showLoading, hideLoading } from 'react-redux-loading-bar';

function isInvalidAction({ type }) {
  if (!type) {
    return true;
  }

  if (includes(type, 'loading-bar') || includes(type, 'redux-form')) {
    return true;
  }

  return false;
}

let loaderAttached = false;

export default function loaderMiddleware() {
  return store => next => (action) => {
    if (isInvalidAction(action) || loaderAttached) {
      return next(action);
    }

    EventEmitter.prototype.on('fetch-start', () => {
      store.dispatch(showLoading());
    });
    EventEmitter.prototype.on('fetch-end', () => {
      store.dispatch(hideLoading());
    });
    loaderAttached = true;

    return next(action);
  };
}
